import { MoneyDTO } from '../../../../system/system-dtos';

export interface AutoWithdrawalsConfigDTO {
  requestToPendingEnabled: boolean;
  requestedToPendingInMinutes?: number;
  pendingToAcceptedEnabled: boolean;
  pendingToAcceptedInMinutes?: number;
  maxNumberOfCancelWithdrawalsPerMonth?: number;
  maxNumberOfCancelWithdrawalsEnabled?: boolean;
  withdrawsArticle?: string;
  enableWithdrawCancellation: boolean;
  tiers: AutoWithdrawalTierDTO[];
  binRangeExclusions: BinRangeExclusionDTO[];
}

export interface AutoWithdrawalTierDTO {
  id: number;
  active: boolean;
  priority: number;
  amountActive: boolean;
  minAmount: MoneyDTO;
  maxAmount: MoneyDTO;
  amountPerDayActive: boolean;
  minAmountPerDay: MoneyDTO;
  maxAmountPerDay: MoneyDTO;
  lifetimeAmountActive: boolean;
  minLifetimeAmount: MoneyDTO;
  maxLifetimeAmount: MoneyDTO;
  cardsNumberActive: boolean;
  cardsNumberMin: number;
  cardsNumberMax: number;
  totalCardsNumberActive: boolean;
  totalCardsNumberMin: number;
  totalCardsNumberMax: number;
  acceptedForCardActive: boolean;
  cardAgeActive: boolean;
  minCardAgeDays: number;
  cardDocumentVerified: boolean;
  riskScoreActive: boolean;
  maxRiskScore: number;
  avsResultActive: boolean;
  avsResultValues: [];
  minAcceptedForCard: number;
  maxAcceptedForCard: number;
  requestsPerDayActive: boolean;
  minRequestsPerDay: number;
  maxRequestsPerDay: number;
  lifetimeRequestsActive: boolean;
  minLifetimeRequests: number;
  maxLifetimeRequests: number;
  bonusAbuseA: boolean;
  bonusAbuseB: boolean;
  bonusAbuseC: boolean;
  withdrawWatch: boolean;
  hvp: boolean;
  allowOnDataMismatch: boolean;
  withdrawLteDepositsForPaymentMethod: boolean;
  minCashStakesToDepositsRatioActive: boolean;
  minCashStakesToDepositsRatio: number;
  trustedCard: boolean;
  // allowedPaymentTypesActive: boolean;
  // paymentTypesDto: [this.data?.paymentTypesDto || []];
}

export interface TiersPrioritiesDTO {
  priorities: TierPriorityDTO[];
}

export interface TierPriorityDTO {
  tierId: number;
  priority: number;
}

export interface BinRangeExclusionDTO {
  id?: number;
  cohortId: number;
  paymentSolutions: string[];
  binRange: number;
}

export const avsResultValues = [
  {
    name: 'A - Postcode and address matched',
    value: 'A',
  },
  {
    name: '7 - Postcode and address matched',
    value: '7',
  },
  {
    name: 'C - Postcode matched; address not matched',
    value: 'C',
  },
  {
    name: '6 - Postcode matched; address not matched',
    value: '6',
  },
  {
    name: 'F - Address matched; postcode not matched',
    value: 'F',
  },
];
